import { useRef } from 'react'
import styles from './styles.module.scss'
import clsx from 'clsx'

export const SingleTooltip = ({ className }) => {
  const refRoot = useRef()

  return (
    <section ref={refRoot} className={clsx(styles.singleTooltip, className)}>
      Click to see more info
    </section>
  )
}
